import React from "react";
import { Modal } from "react-bootstrap";
import "./ModelSettings.css";

interface ModelSettingsProps {
  show: boolean;
  handleClose: () => void;
  handleSetSaveChanges: (flag: boolean) => void;
  handleClosePopupParent:()=>void;
}
const ModelSettingsPopupCancel = ({
  show,
  handleClose,
  handleSetSaveChanges,
  handleClosePopupParent,
}: ModelSettingsProps) => {
  const handleIgnoreChanges = () => {
    handleSetSaveChanges(false);
    handleClose();
    handleClosePopupParent();
  };

  const handleSaveChanges = () => {
    handleSetSaveChanges(true);
    handleClose();
  };
  return (
    <>
      {show && <div className="modal-overlay" />}
      <Modal className="CancelModal" show={show} backdrop="static" centered>
        <Modal.Header className="modelSettingsPopupHeaderCancel border-0">
          <Modal.Title className="settingPopupHeader">
            Unsaved changes
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={`CancelModalBody border-0 rounded-bottom-4`}>
          <div className="cancel-popup-conatiner ">
            <p 
            style={{
              fontSize:"14px",
            }}
            >Don't lose your work! Save changes or exit without saving?</p>
            <div className="line-sepeartor-cancelPopup mt-3 mb-3"></div>
            <div className="buttons-cancel-popup">
              <button
                className="CancelDeletePersonaBtn model-settings-ignore-btn modal-settings"
                onClick={handleIgnoreChanges}
               
              >
                Ignore
              </button>
              <button className="createPersonaBtn modal-settings" onClick={handleSaveChanges}>
                Save changes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );

};

export default ModelSettingsPopupCancel;
